import React, { FC } from 'react';
import {
  AuthContainer,
  Container,
  LogoContainer,
  LogoText,
} from '../ui/common';

import { logoIcon as WpLogoIcon, logoName as WpLogoName, appLogoIconAlt, appLogoNameAlt } from '../sportConfig';
import { PurchaseContainer } from './PurchaseContainer';
import { useNavigate } from 'react-router-dom';

export const PurchasePage: FC = () => {
  const navigate = useNavigate();
  return (
    <AuthContainer>
      <Container>
        <LogoContainer>
          <img src={WpLogoIcon} alt={appLogoIconAlt} />
          <LogoText
            src={WpLogoName}
            alt={appLogoNameAlt}
            width={640}
            height={260}
          />
        </LogoContainer>
        <PurchaseContainer onAccessGranted={() => navigate('/')} />
      </Container>
    </AuthContainer>
  );
};
